import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs';
import { ShortcutModel } from 'src/app/models/shortcut.model';
import { ShortcutService } from 'src/app/services/shortcut.service';

@Component({
  selector: 'tx-quicktext-dialog',
  templateUrl: './quicktext-dialog.component.html',
  styleUrl: './quicktext-dialog.component.scss'
})
export class QuicktextDialogComponent implements OnInit {

  private quicktextShortcuts: ShortcutModel[] = [];
  public filteredQuicktexts: ShortcutModel[] = [];

  constructor(public activeModal: NgbActiveModal, private shortcutService: ShortcutService) {

  }

  ngOnInit(): void {
    this.shortcutService.getUserShortcuts()
    .pipe(take(1))
    .subscribe((res: ShortcutModel[]) => {
      if (res) {
        this.quicktextShortcuts = res;
        this.filteredQuicktexts = res;
      }
    })
  }

  insertQuicktext(text: string) {
    this.activeModal.close(text);
  }

  onFilterTextChanged(event: Event) {
    const filterElement = event.target as HTMLInputElement;
    if (filterElement) {
      const filterText = filterElement.value.toLowerCase();
      this.filteredQuicktexts = this.quicktextShortcuts.filter(q => 
                              q.title.toLowerCase().includes(filterText) || q.text.toLowerCase().includes(filterText));
    }
  }

}
